// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e75445ad","512":"ba9daf1b"}[chunkId] + ".chunk.js";
};